"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSTANTS = void 0;
var CONSTANTS;
(function (CONSTANTS) {
    CONSTANTS["onBoardingLink"] = "https://www.ledger.com/pages/ledger-live";
    CONSTANTS["white"] = "#fff";
    CONSTANTS["ledgerGreen"] = "#44bdbd";
    CONSTANTS["logoutMessage"] = "Error logging out";
})(CONSTANTS = exports.CONSTANTS || (exports.CONSTANTS = {}));
